import SvgIcon from "@mui/material/SvgIcon";
import React from "react";

export function QRIcon(props) {
    return (
        <SvgIcon {...props}>
            <svg width="21" height="22" viewBox="0 0 21 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="0.5" y="2.5" width="18" height="18" rx="1.5" stroke="#4B92FE"/>
                <rect x="2.25" y="4.25" width="2.5" height="2.5" stroke="#4B92FE" strokeWidth="0.5"/>
                <rect x="3" y="5" width="1" height="1" fill="#4B92FE"/>
                <rect x="14.25" y="4.25" width="2.5" height="2.5" stroke="#4B92FE" strokeWidth="0.5"/>
                <rect x="15" y="5" width="1" height="1" fill="#4B92FE"/>
                <rect x="2.25" y="16.25" width="2.5" height="2.5" stroke="#4B92FE" strokeWidth="0.5"/>
                <rect x="3" y="17" width="1" height="1" fill="#4B92FE"/>
                <line x1="12.5" y1="5" x2="12.5" y2="8" stroke="#4B92FE"/>
                <line x1="10.5" y1="7" x2="10.5" y2="10" stroke="#4B92FE"/>
                <line x1="12.5" y1="9" x2="12.5" y2="12" stroke="#4B92FE"/>
                <line x1="11.5" y1="12" x2="11.5" y2="15" stroke="#4B92FE"/>
                <line x1="6.5" y1="9" x2="6.5" y2="12" stroke="#4B92FE"/>
                <line x1="9.5" y1="6" x2="9.5" y2="9" stroke="#4B92FE"/>
                <line x1="8.5" y1="13" x2="8.5" y2="16" stroke="#4B92FE"/>
                <line x1="3.5" y1="8" x2="3.5" y2="11" stroke="#4B92FE"/>
                <line x1="6.5" y1="4" x2="6.5" y2="6" stroke="#4B92FE"/>
                <line x1="14.5" y1="12" x2="14.5" y2="13" stroke="#4B92FE"/>
                <line x1="14.5" y1="9" x2="14.5" y2="10" stroke="#4B92FE"/>
                <line x1="8.5" y1="12" x2="8.5" y2="13" stroke="#4B92FE"/>
                <line x1="10.5" y1="11" x2="10.5" y2="12" stroke="#4B92FE"/>
                <line x1="15.5" y1="14" x2="15.5" y2="15" stroke="#4B92FE"/>
                <line x1="13.5" y1="17" x2="13.5" y2="18" stroke="#4B92FE"/>
                <line x1="15.5" y1="15" x2="15.5" y2="16" stroke="#4B92FE"/>
                <line x1="14.5" y1="16" x2="14.5" y2="17" stroke="#4B92FE"/>
                <line x1="15.5" y1="11" x2="15.5" y2="12" stroke="#4B92FE"/>
                <line x1="6.5" y1="7" x2="6.5" y2="8" stroke="#4B92FE"/>
                <line x1="2.5" y1="9" x2="2.5" y2="10" stroke="#4B92FE"/>
                <line x1="10.5" y1="17" x2="10.5" y2="18" stroke="#4B92FE"/>
                <line x1="11.5" y1="5" x2="11.5" y2="6" stroke="#4B92FE"/>
                <line x1="11.5" y1="4" x2="11.5" y2="5" stroke="#4B92FE"/>
                <line x1="7.5" y1="16" x2="7.5" y2="17" stroke="#4B92FE"/>
                <line x1="15.5" y1="8" x2="15.5" y2="9" stroke="#4B92FE"/>
                <line x1="16.5" y1="9" x2="16.5" y2="10" stroke="#4B92FE"/>
                <line x1="15.5" y1="17" x2="15.5" y2="18" stroke="#4B92FE"/>
                <line x1="15.5" y1="18" x2="15.5" y2="19" stroke="#4B92FE"/>
                <line x1="14.5" y1="19" x2="14.5" y2="20" stroke="#4B92FE"/>
                <line x1="16.5" y1="15" x2="16.5" y2="16" stroke="#4B92FE"/>
                <line x1="8.5" y1="6" x2="8.5" y2="7" stroke="#4B92FE"/>
                <line x1="5.5" y1="11" x2="5.5" y2="12" stroke="#4B92FE"/>
                <line x1="15.5" y1="12" x2="15.5" y2="13" stroke="#4B92FE"/>
                <line x1="16.5" y1="12" x2="16.5" y2="13" stroke="#4B92FE"/>
                <line x1="8.5" y1="5" x2="8.5" y2="6" stroke="#4B92FE"/>
                <line x1="3.5" y1="15" x2="3.5" y2="16" stroke="#4B92FE"/>
                <line x1="9.5" y1="13" x2="9.5" y2="16" stroke="#4B92FE"/>
                <line x1="3.5" y1="13" x2="3.5" y2="14" stroke="#4B92FE"/>
                <line x1="5.00568" y1="14.5" x2="8.00548" y2="14.5341" stroke="#4B92FE"/>
                <line x1="11.5105" y1="14.9689" x2="14.5098" y2="15.0318" stroke="#4B92FE"/>
                <line x1="12.5" y1="13" x2="12.5" y2="16" stroke="#4B92FE"/>
                <line x1="7.5" y1="18" x2="7.5" y2="19" stroke="#4B92FE"/>
                <line x1="11.25" y1="18.064" x2="11.25" y2="16.4718" stroke="#4B92FE"/>
                <line x1="7.5" y1="9" x2="7.5" y2="12" stroke="#4B92FE"/>
            </svg>
        </SvgIcon>
    )
}

